export default __webpack_public_path__ + "static/media/pattern_2.bdfc3c0a.png";